import { VERTICALS } from '../data/verticals';
import VerticalPage from './VerticalPage';

const GatedCommunities = () => <VerticalPage config={VERTICALS['gated-communities']} />;

export default GatedCommunities;
